module.exports = __webpack_public_path__ + "assets/img/living_5-4.717fcf43.jpg";